module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "list"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/endpapers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endpapers: Rockwell’s letter to his assistant Franklin Lischke "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/frontis#front",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Triple Self-Portrait")]), _vm._v(", 1961 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#ill-1"
    }
  }, [_vm._v("Rockwell wrote out this joke about an elephant and gave it to a psychiatrist.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ill-2"
    }
  }, [_vm._v("Rockwell wondered if he inherited his drawing skill from his grandfather, Howard Hill, creator of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Family of Grouse in a Landscape.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ill-3"
    }
  }, [_vm._v("Mary Ann Rockwell, the artist’s mother, later known as Nancy")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ill-4"
    }
  }, [_vm._v("Norman and his older brother, Jarvis, display frogs caught during one of their summers in Warwick, New York. Although Norman was taller than Jarvis, he claimed to feel physically outmatched by him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ill-5"
    }
  }, [_vm._v("George Bridgman’s drawing class at the Art Students League in the fall of 1912 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of the Art Students League of New York)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ill-6"
    }
  }, [_vm._v("This charcoal drawing remains Rockwell’s earliest known work. He intended it as an illustration of a scene in Oliver Goldsmith’s poem “The Deserted Village.” "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of the Art Students League of New York)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ill-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell’s first published book illustration showed the explorer Samuel de Champlain on the rocks of Quebec.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ill-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With its striped swimming trunks and cropped legs, Rockwell’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Boys’ Life")]), _vm._v(" cover, from August 1915, strips away moldy detail in favor of modern spareness. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of the National Scouting Museum, Irving, Texas)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ill-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A scout named Gailey is ridiculed for bringing pink pajamas to camp in this 1913 illustration, which Rockwell drew for Edward Cave’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Boy Scout Camp Book")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ill-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The illustrator Charles Dana Gibson specialized in images of busty women with big hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ill-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Magic Football (“I thought you were wrong”)")]), _vm._v(" ran as a story illustration in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("St. Nicholas")]), _vm._v(", the best of the children’s magazines, in December 1914. The medium is oil on canvas "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("en grisaille.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ill-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Montgomery Flagg inserted his own face into his portrait of Uncle Sam in his Army recruiting poster of 1916. He was influenced by the British poster of Lord Kitchener created by Alfred Leete.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ill-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Clubhouse Examination")]), _vm._v(", 1917, riffed on James Montgomery Flagg’s recruiting poster.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ill-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("During his stint in the Navy, Rockwell received permission to continue painting magazine covers—so long as he portrayed sailors.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ill-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Billy Payne’s best friend, Eddie Carson, posed for a Boy Scouts recruiting poster, which also ran as the cover of the July 1919 issue of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Boys’ Life")]), _vm._v(". "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of the National Scouting Museum, Irving, Texas)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ill-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell poses with his model Billy Payne, circa 1917.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ill-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Boy with Dog in Picnic Basket")]), _vm._v(" ran on the May 15, 1920, cover of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Saturday Evening Post")]), _vm._v(" and amounts to a tender elegy for a boy who fell to his death.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ill-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell dressed up as a Spanish matador for a costume party in April 1920, with his wife, Irene. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Photograph by Paul Thompson)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ill-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irene Rockwell seldom modeled for Rockwell and made one of her few appearances on the cover of a 1921 issue of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Literary Digest.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ill-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("No Swimming")]), _vm._v(", 1921: One of Rockwell’s most famous paintings has less to do with putting on a costume than taking it off.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ill-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arrow Collar Man, as created by J. C. Leyendecker, was selling not just a shirt but the promise of urban sophistication. This advertisement appeared in 1912.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ill-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On a visit to Clyde Forsythe in Southern California, Rockwell is introduced to the actor Charles “Buddy” Rogers, a silent film star. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ill-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Doctor and Doll")]), _vm._v(", 1929, acknowledges Rockwell’s affection for Rembrandt’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Anatomy Lesson")]), _vm._v(". "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ill-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norman and Mary in Los Angeles, on March 19, 1930, the day they applied for a marriage license")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ill-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fred Hildebrandt took pictures of Rockwell on their treks through the San Gabriel Mountains. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of Alexandra Hoy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ill-25a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fred Hildebrandt took pictures of Rockwell on their treks through the San Gabriel Mountains. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of Alexandra Hoy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ill-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fred Hildebrandt, an artist, worked as Rockwell’s studio assistant and model for a decade. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of Gary Hallwood)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ill-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Colonial Couple")]), _vm._v(", 1931 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ill-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell shows off a moose head outside his cabin at the Segouin camp in Quebec, where he was assisted by two French-speaking guides. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Photograph by Fred Hildebrandt; courtesy of Alexandra Hoy)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ill-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An illustration for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Adventures of Tom Sawyer")]), _vm._v(" harks back to the tragedy of Billy Payne.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ill-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Ticket Agent")]), _vm._v(", 1937")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ill-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Rockwell, her three sons, and an unidentified girl aboard the SS "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bremen")]), _vm._v(", en route to London, March 1938 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of Jarvis Rockwell)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ill-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Blank Canvas")]), _vm._v(", 1938 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ill-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Freedom of Speech")]), _vm._v(", 1942 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ill-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Freedom of Worship")]), _vm._v(", 1942 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ill-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Freedom from Fear")]), _vm._v(", 1942 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ill-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("My Studio Burns")]), _vm._v(", 1943, relayed news of a catastrophe as so many charming vignettes.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ill-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rosie the Riveter")]), _vm._v(" "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Crystal Bridges Museum of American Art, Bentonville, Arkansas)")]), _vm._v(" riffed on Michelangelo’s figure of Isaiah on the Sistine Chapel ceiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ill-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rosie the Riveter")]), _vm._v(" "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Crystal Bridges Museum of American Art, Bentonville, Arkansas)")]), _vm._v(" riffed on Michelangelo’s figure of Isaiah on the Sistine Chapel ceiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ill-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rockwell family: Norman, Mary, Jerry, Tommy, Peter, and Raleigh, circa 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ill-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rockwell and Schaeffer families socializing in Arlington, Vermont")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ill-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Homecoming G.I.")]), _vm._v(" was used by the federal government to help promote the final War Loan Drive.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ill-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell’s new dog, a springer spaniel named Butch, appeared in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Going and Coming")]), _vm._v(". This is a charcoal sketch for the painting. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Collection of George Lucas)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ill-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Famous Twelve in 1949: Fred Ludekens, Al Dorne, Norman Rockwell, Peter Helck, Al Parker, Jon Whitcomb, Stevan Dohanos, Ben Stahl, Austin Briggs, Harold von Schmidt, Robert Fawcett, and John Atherton "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of the Famous Artists School)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ill-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell displays his Christmas card designs to Joyce C. Hall, on February 14, 1948, in Kansas City. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of Hallmark Cards)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ill-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Christmas Homecoming")]), _vm._v(", the defining image of holiday togetherness, appeared on the cover of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Saturday Evening Post")]), _vm._v(" on December 25, 1948.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ill-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell with his friend Joe Mugnaini, a teacher at Otis College of Art and Design")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ill-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The New Television Set")]), _vm._v(", 1949 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Los Angeles County Museum of Art, Los Angeles)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ill-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell decorates a cake for Grandma Moses’s eighty-ninth birthday in 1949. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ill-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell and Mary in his studio. With its knotty-pine walls and a reproduction of Pieter Bruegel’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Peasant Dance")]), _vm._v(" hanging over the mantelpiece, the studio was more elaborately decorated than his home. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("("), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("TOP")]), _vm._v(": photograph by Arthur Johnson; "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("BOTTOM")]), _vm._v(": photograph by Bill Scovill, courtesy of the Famous Artists School)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ill-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Post")]), _vm._v(" did a survey asking readers to name their favorite Rockwell cover, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Saying Grace")]), _vm._v(" won hands-down. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ill-51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Shiner")]), _vm._v(", 1954, stands with "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rosie the Riveter")]), _vm._v(" as a protofeminist representation of female strength. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ill-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Erik Erikson, soon after he moved to Stockbridge, in his yard "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Photograph by Clemens Kalischer)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ill-53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Girl at Mirror")]), _vm._v(", 1954 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ill-54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Breaking Home Ties")]), _vm._v(", 1954 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ill-55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Art Critic")]), _vm._v(", 1955 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ill-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell socializing with Erik Erikson and other members of the Marching and Chowder Society, circa 1960")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ill-57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Before the Shot")]), _vm._v(", 1958 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ill-58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Runaway")]), _vm._v(", 1958 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ill-59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Golden Rule")]), _vm._v(", 1961 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ill-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norman and Molly Rockwell, photographed in 1962 by his assistant Bill Scovill")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ill-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell reads a toast to Erik Erikson on March 31, 1962, at a dinner for the Berkshire Art Center. Molly is on Rockwell’s right, Joan Erikson is on his left, and Peggy Best, who organized the event, is sitting to the left foreground, back to camera. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of Jonathan Best)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ill-62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Problem We All Live With")]), _vm._v(", which appeared as a two-page spread in "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Look")]), _vm._v(" magazine on January 14, 1964, remains the single most famous painting of the civil rights movement. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ill-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Problem We All Live With")]), _vm._v(" echoes a news photograph of Ruby Bridges being escorted from school by U.S. deputy marshals. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of AP)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ill-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After seeing Peter Hurd’s portrait of him, LBJ denounced it and decided retroactively that he liked Rockwell’s earlier portrait of him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ill-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell painted "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Stockbridge—Main Street at Christmas")]), _vm._v(" in 1967, after Arlo Guthrie’s “Alice’s Restaurant Massacree” made its radio debut on WBAI-FM. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ill-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Al Kooper, Norman Rockwell, and Mike Bloomfield "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Photograph by Bob Cato; courtesy of Al Kooper)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ill-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In 1968 Rockwell provided the portrait for the album jacket of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Live Adventures of Mike Bloomfield and Al Kooper")]), _vm._v(". "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Courtesy of Al Kooper)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL-3__NOBOT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ill-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockwell’s last painting portrays a scene from local history, and brings together a missionary and an Indian.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMSH"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("COLOR INSERT")])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Boy with Baby Carriage")]), _vm._v(", 1916, was Rockwell’s first cover for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Saturday Evening Post")]), _vm._v(". Billy Payne posed for all three boys. "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Gary Cooper as The Texan")]), _vm._v(", 1930 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Collection of Steven Spielberg)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Movie Starlet and Reporters")]), _vm._v(", 1936 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Collection of Steven Spielberg)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Freedom from Want")]), _vm._v(", 1943 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tattoo Artist")]), _vm._v(", 1944 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Brooklyn Museum, Brooklyn, New York)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Shuffleton’s Barbershop")]), _vm._v(", 1950 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Marriage License")]), _vm._v(", 1955 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Norman Rockwell Museum, Stockbridge, Massachusetts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "ILL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8  "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Connoisseur")]), _vm._v(", 1962 "), _c('span', {
    staticClass: "font-small"
  }, [_vm._v("(Collection of Steven Spielberg)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72c09cb5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustrations.vue
// module id = 78
// module chunks = 0